import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { EMAIL_FORMAT_RE } from '../healthpicks.constants';

@Component({
  selector: 'app-healthpicks-forgot-password',
  templateUrl: './healthpicks-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    '../style/hp-shared.css',
    './healthpicks-forgot-password.component.css',
  ],
})
export class HealthpicksForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit
{

  async init(): Promise<void> {}

  async changePassword(): Promise<void> {
    const emailTrimmed = this.email.trim();
    if (!emailTrimmed) {
      this.errorMessages.forgetpassword.email =
        'メールアドレスを入力してください。';
      return;
    }
    if (!EMAIL_FORMAT_RE.test(emailTrimmed)) {
      this.errorMessages.forgetpassword.email =
        'メールアドレスまたはパスワードを確認してください。';
      return;
    }
    this.email = emailTrimmed;

    // Delegate to BaseLoginComponent which handles the actual request and navigation
    return super.changePassword();
  }
}
